import KaraokePlayer from "../../../views/digibord/content/KaraokePlayer.vue";

export default function createKaraokePlayerRoute(name) {
  return [
    {
      path: "lied/:songSlug?/",
      name,
      component: KaraokePlayer,
      meta: {
        containerClass: "showSongPlayer",
      },
    },
  ];
}
